<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="PDM月销售数据 center_2"
      :rightTitle="`${formatTime(pieDate, 'yyyy年MM月')} 合计：${total_money}`"
      :tooltipText="'开单提交实时金额数据，不含本厂责任售后'"
    >
    </chart-title>
    <div class="two_col">
      <date-change-card
        height="55%"
        @leftClick="leftClick(1)"
        @rightClick="rightClick(1)"
      >
        <el-row :gutter="10" style="height: 100%" slot="main">
          <el-col :span="16" style="position: relative"
            ><div id="center_2_left" />
            <div
              class="iconfont icon-sanjiaoxing1 chart_icon_animation animation_rotateY-reverse"
            ></div>
          </el-col>
          <el-col :span="8" class="num_card">
            <div
              class="num_card_item"
              v-for="(item, index) in pieChartData"
              :key="index"
            >
              <div class="right_line">
                <dv-decoration-6 style="width: 54px; height: 10px" />
              </div>
              <div class="num_card_item_title">{{ item.name }}</div>
              <div class="num_card_item_num">
                <span class="num">{{ item.value }}</span>
                <!-- <span class="unit">元</span> -->
              </div>
            </div>
            <!-- <div class="loader loader-4"></div> -->
          </el-col>
        </el-row>
      </date-change-card>
      <date-change-card
        height="45%"
        @leftClick="leftClick(2)"
        @rightClick="rightClick(2)"
      >
        <div id="center_2_right" slot="main" />
      </date-change-card>
    </div>
  </div>
</template>

<script>
import { monthlySalesData } from "@/api/cockpit/jyl";
import {
  formatTime,
  getNextMonth,
  getNextYear,
  getFirstDate,
  arrDataFormat,
} from "@/utils/index";
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
export default {
  mixins: [resize],
  name: "center_2",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      chartLeft: null,
      chartRight: null,
      pieChartData: [],
      categoryChartData: [],
      pieDate: new Date(),
      categoryDate: new Date(),
      total_money: 0,
    };
  },
  props: {},
  created() {},
  mounted() {
    this.getData(this.pieDate, 3);
  },

  beforeDestroy() {
    if (!this.chartLeft && !this.chartRight) {
      return;
    }
    this.chartLeft.dispose();
    this.chartLeft = null;
    this.chartRight.dispose();
    this.chartRight = null;
  },
  methods: {
    formatTime,
    //获取数据  type 1:获取饼图数据;type 2:获取折线图数据；type：3 获取饼图和折线图数据
    getData(date, type) {
      monthlySalesData({
        add_time: getFirstDate(date, "yyyy-MM-dd"),
        type: "month",
      }).then((resp) => {
        if (type == 1) {
          this.pieChartData = arrDataFormat(resp.data.list);
          this.total_money = resp.data.total_money;
        } else if (type == 2) {
          this.categoryChartData = arrDataFormat(resp.data.all_month);
        } else {
          this.pieChartData = arrDataFormat(resp.data.list);
          this.categoryChartData = arrDataFormat(resp.data.all_month);
          this.total_money = resp.data.total_money;
        }

        this.initChart();
      });
    },
    initChart() {
      this.chartLeft = this.$echarts.init(
        document.getElementById("center_2_left")
      );
      this.setOptions();
      this.chartRight = this.$echarts.init(
        document.getElementById("center_2_right")
      );
      this.setOptionsRight();
    },
    setOptions() {
      this.chartLeft.setOption({
        title: {
          subtext: `PDM各销售公司月销售额`,
          left: "left",
          subtextStyle: {
            color: "#C0C4CC",
          },
        },
        color: ["#009dff", "#22e4ff", "#3bffd0"],
        tooltip: {
          trigger: "item",
        },
        legend: {
          show: false,
          orient: "vertical",
          right: "15%",
          top: "center",
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        series: [
          {
            type: "pie",
            radius: ["30%", "60%"],
            roseType: "area",
            right: "2%",
            data: this.pieChartData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              formatter: "{b}：{@2012}",
              color: "#C0C4CC",
            },
            labelLine: {
              length: 2,
            },
          },
        ],
      });
    },
    setOptionsRight() {
      const arr = JSON.parse(JSON.stringify(this.categoryChartData));
      const maxMonth = arr.sort((a, b) => b.value - a.value)[0];
      this.chartRight.setOption({
        title: {
          subtext: `${formatTime(this.categoryDate, "yyyy年")}每月销售额`,
          left: "center",
          top: "8%",
          subtextStyle: {
            color: "#C0C4CC",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        grid: {
          bottom: "18%",
          left: "18%",
          right: "12%",
        },
        xAxis: {
          type: "category",
          data: this.categoryChartData.map(
            (m) => `${this.numberConvert(m.name)}月`
          ),
          axisLabel: {
            color: "#909399",
            fontSize: "10",
          },
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#606266",
            fontSize: "10",
          },
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#606266",
              type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
            },
          },
        },
        series: [
          {
            data: this.categoryChartData.map((m) => m.value),
            type: "line",
            areaStyle: { opacity: 0.3 },
            color: "#1c7ce8",
          },
          {
            // 设置涟漪特效动画
            type: "effectScatter",
            // 有三种: cartesian2d(二维的直角坐标系) polar(极坐标系) geo(地理坐标系) ,此需求使用cartesian2d
            coordinateSystem: "cartesian2d",
            // 单个闪烁点 ↓
            data: [
              {
                value: [
                  `${this.numberConvert(maxMonth.name)}月`,
                  maxMonth.value,
                ],
                symbolSize: 9,
              },
            ], //2d坐标系--[x轴, y轴, 标记大小]

            // 多个闪烁点 ↓
            // 方法一 -- start:
            // data: [{value:['Mon',820],symbolSize:10},{value:['Tue',932],symbolSize:10}],
            // 方法一 -- end

            // 方法二 -- start:
            // data: [['Mon',820],['Tue',932]], //2d坐标系--[x轴, y轴, 标记大小]
            // symbolSize: 10,
            // 方法二 -- end

            // 何时显示特效:'render'-绘制完成后显示特效 'emphasis'-高亮（hover）的时候显示特效
            showEffectOn: "render",
            // 涟漪特效配置
            rippleEffect: {
              // 波纹的绘制方式,可选'stroke'和'fill'
              brushType: "stroke",
            },
            hoverAnimation: true,
            itemStyle: {
              normal: {
                color: "rgba(255,255,255,0.9)",
                shadowBlur: 38,
                shadowColor: "rgba(255,255,255,0.9)",
              },
            },
            zlevel: 1,
            tooltip: {
              show: false,
            },
          },
        ],
      });
    },
    //前一月
    leftClick(type) {
      if (type == 1) {
        this.pieDate = getNextMonth(formatTime(this.pieDate, "yyyy-MM-dd"), -1);
        this.getData(this.pieDate, type);
      } else {
        this.categoryDate = getNextYear(
          formatTime(this.categoryDate, "yyyy-MM-dd"),
          -1
        );
        this.getData(this.categoryDate, type);
      }
    },
    //后一月
    rightClick(type) {
      if (type == 1) {
        this.pieDate = getNextMonth(formatTime(this.pieDate, "yyyy-MM-dd"), +1);
        this.getData(this.pieDate, type);
      } else {
        this.categoryDate = getNextYear(
          formatTime(this.categoryDate, "yyyy-MM-dd"),
          +1
        );
        this.getData(this.categoryDate, type);
      }
    },
    //数字大写转换
    numberConvert(val) {
      let num = "";
      switch (val) {
        case "1":
          num = "一";
          break;
        case "2":
          num = "二";
          break;
        case "3":
          num = "三";
          break;
        case "4":
          num = "四";
          break;
        case "5":
          num = "五";
          break;
        case "6":
          num = "六";
          break;
        case "7":
          num = "七";
          break;
        case "8":
          num = "八";
          break;
        case "9":
          num = "九";
          break;
        case "10":
          num = "十";
          break;
        case "11":
          num = "十一";
          break;
        case "12":
          num = "十二";
          break;
        default:
          break;
      }
      return num;
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 58vh;
  .two_col {
    padding: 0 10px;
    height: calc(100% - 30px);
    .num_card {
      padding-left: 20px !important;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .num_card_item {
        position: relative;
        width: 160px;
        background: radial-gradient(
          rgba(89, 132, 173, 0.45) 20%,
          rgba(89, 132, 173, 0.05) 80%
        );
        color: #8fb5db;
        border: 2px solid #0c2b4a;
        padding: 10px 12px;
        border-radius: 5px;
        .right_line {
          position: absolute;
          top: -6px;
          right: 0px;
        }
        .num_card_item_title {
          font-size: 14px;
          font-weight: bold;
        }
        .num_card_item_num {
          margin-top: 12px;
          .num {
            font-size: 24px;
            font-weight: bold;
          }
          .unit {
            margin-left: 5px;
            font-weight: bold;
          }
        }
      }
    }
    .chart_icon_animation {
      position: absolute;
      left: 45.6%;
      top: 46%;
      font-size: 40px;
      color: #909399;
    }
  }
  #center_2_left {
    height: 100%;
  }
  #center_2_right {
    height: 100%;
  }
}
</style>
